import { ReactNode } from "react";

interface DealerTabStateProps<T> {
  data: T[] | null;
  loading: boolean;
  error: string | null;
  label: string;
  emptyMessage: string;
  children: (items: T[]) => ReactNode;
}

export function DealerTabState<T>({ data, loading, error, label, emptyMessage, children }: DealerTabStateProps<T>) {
  if (loading) return <p className="text-muted-foreground text-sm">Loading {label}...</p>;

  if (error) {
    return (
      <div className="border-destructive text-destructive rounded-md border p-3 text-sm" role="alert">
        {error}
      </div>
    );
  }

  if (!data || data.length === 0) return <div className="rounded-md border p-3 text-sm">{emptyMessage}</div>;

  return <>{children(data)}</>;
}

export function DealerTabSection({ title, count, children }: { title: string; count: number; children: ReactNode }) {
  return (
    <section className="min-w-0 rounded-md border">
      <div className="border-b px-4 py-3">
        <h2 className="font-semibold">
          {title} ({count})
        </h2>
      </div>
      {children}
    </section>
  );
}
